"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var timeout_1 = require("./timeout");
Object.defineProperty(exports, "timeout", { enumerable: true, get: function () { return timeout_1.default; } });
var getFibonacciSequence_1 = require("./getFibonacciSequence");
Object.defineProperty(exports, "getFibbonacciSequence", { enumerable: true, get: function () { return getFibonacciSequence_1.default; } });
var isSimpleDate_1 = require("./isSimpleDate");
Object.defineProperty(exports, "isSimpleDate", { enumerable: true, get: function () { return isSimpleDate_1.default; } });
//# sourceMappingURL=index.js.map